import React, { useState, useEffect } from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useParams, useNavigate } from "react-router-dom";
import Constants from "../../utils/Constants";
import SplashScreen from "../../components/loader/SplashScreen/SplashScreen";
import { View, ChevronLeft } from "@carbon/icons-react";
import ReactPaginate from "react-paginate";
import CampaignResponseDetail from "./CampaignResponseDetail";

const CampaignResponseList = () => {
  const { id: campaignId } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [selectedResponse, setSelectedResponse] = useState(null);
  const [showDetail, setShowDetail] = useState(false);

  const ResponsesApi = (page) => {
    return axios({
      method: "get",
      params: {
        page: page || 1,
        limit: 100,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${Constants.url}surveys/campaigns/${campaignId}/responses`,
    }).then((res) => {
      console.log("data: ", res.data);
      return res.data;
    });
  };

  const {
    data: ResponsesData,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["campaign-responses", campaignId, page],
    queryFn: () => ResponsesApi(page),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!campaignId,
  });

  useEffect(() => {
    if (campaignId) {
      refetch();
    }
  }, [campaignId, refetch]);

  const responses = ResponsesData?.data?.responses || [];
  const totalResponses = ResponsesData?.total || 0;

  const handleViewResponse = (response) => {
    setSelectedResponse(response);
    setShowDetail(true);
  };

  const handleCloseDetail = () => {
    setShowDetail(false);
    setSelectedResponse(null);
  };

  if (showDetail && selectedResponse) {
    return (
      <CampaignResponseDetail
        response={selectedResponse}
        onBack={handleCloseDetail}
      />
    );
  }

  return (
    <>
      {isLoading ? (
        <div className="dashboardWrp uk-padding" style={{ textAlign: "center", padding: "40px" }}>
          <p>Loading...</p>
        </div>
      ) : !loader ? (
        <div className="dashboardWrp uk-padding">
          <div className="uk-container uk-container-expand">
            <div className="uk-margin-medium-bottom">
              <button
                className="uk-button uk-button-secondary back-btn  "
                onClick={() => navigate("/survey-campaigns")}
                
              >
                <ChevronLeft size={24} />
                Back to Campaigns
              </button>
            </div>

            <div className="uk-margin">
              <div className="uk-flex uk-flex-between">
                <div>
                  <h2>Campaign Responses</h2>
                  <p style={{ color: "#666", fontSize: "14px", margin: "8px 0 0 0" }}>
                    Total Responses: {ResponsesData?.total || 0}
                  </p>
                </div>
              </div>
            </div>

            <div className="analyticsTableWrp uk-overflow-auto">
              <table className="uk-table uk-table-striped">
                <thead className="table-header-shadow">
                  <tr>
                    <th>S.No</th>
                    <th>Customer Email</th>
                    <th>Customer Phone</th>
                    <th>Order No</th>
                    <th>Status</th>
                    <th>Submitted At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {responses?.map((response, index) => (
                    <tr key={response._id}>
                      <td>{(page - 1) * 100 + (index + 1)}</td>
                      <td>{response?.customerId?.email || "-"}</td>
                      <td>{response?.customerId?.phone || "-"}</td>
                      <td>{response?.orderId?.orderNo || "-"}</td>
                      <td>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 14px",
                            borderRadius: "16px",
                            fontSize: "12px",
                            fontWeight: "600",
                            textTransform: "capitalize",
                            backgroundColor: response.isCompleted
                              ? "#32d296"
                              : "rgb(240 154 30)",
                            color: "#fff",
                          }}
                        >
                          {response.isCompleted ? "Completed" : "Incomplete"}
                        </span>
                      </td>
                      <td>
                        {response.submittedAt
                          ? new Date(response.submittedAt).toLocaleString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              }
                            )
                          : "-"}
                      </td>
                      <td>
                        <button
                          className="uk-button uk-button-text"
                          onClick={() => handleViewResponse(response)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            color: "#666",
                            padding: "0",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          <View size={18} />
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {responses?.length === 0 && (
                <div className="uk-padding uk-text-center">
                  <p style={{ color: "#999", fontSize: "14px" }}>
                    No responses found for this campaign
                  </p>
                </div>
              )}
              <div className="paginationcard uk-card uk-card-default uk-margin-remove-top">
                <ReactPaginate
                  previousLabel={"←"}
                  nextLabel={"→"}
                  breakLabel={"..."}
                  pageCount={Math.ceil((totalResponses || 0) / 100)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => setPage(e.selected + 1)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  forcePage={page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        // <SplashScreen />
        <>
        
        </>
      )}
    </>
  );
};

export default CampaignResponseList;
